import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CpModal } from '../../components/modal/cp-modal';
import { CpParaRegular } from '../../components/typography/typo';

export const CpDeleteChatModal: React.FC<{
  visible?: boolean;
  onOk: VoidFunction;
  onCancel: VoidFunction;
}> = ({ visible, onOk, onCancel }) => {
  return (
    <CpModal
      visible={visible}
      getContainer={() =>
        document.querySelector('#cp-modal-root') as HTMLElement
      }
      onOk={onOk}
      onCancel={onCancel}
      type="error"
      title={
        <FormattedMessage id="projects.conversations.delete.confirm_title" />
      }
    >
      <CpParaRegular>
        <FormattedMessage id="projects.conversations.delete.confirm_info" />
      </CpParaRegular>
    </CpModal>
  );
};
